import { useState } from 'react';
import { Box } from '@mui/material';
import {
  CustomAutoComplete,
  CustomButton,
  DecimalTextField,
  DrawerFormSection,
  InfoTooltip,
} from '../../../common/components';
import { drawerFieldSpan } from '../../../common/styles';
import { RECEIPT_ALLOCATION_TEXTS as TEXTS } from '../constants/supplyOrdersConstants';
import { proposeReceiptAllocation } from '../utils/receiptAllocationUtils';

/** Distribución propuesta para remitos que informan un total por artículo. */
const ReceiptAllocationFields = ({ items, onAllocation, disabled }) => {
  const [articleId, setArticleId] = useState('');
  const [total, setTotal] = useState('');
  const unique = new Map(
    items.map((row) => [row.uuid_inventory_article, row.article_name_snapshot])
  );
  const options = [...unique].map(([value, label]) => ({ value, label }));
  const proposal = total === '' ? null : proposeReceiptAllocation(items, articleId, total);
  return (
    <DrawerFormSection title={TEXTS.title} action={<InfoTooltip lines={[TEXTS.info]} />}>
      <CustomAutoComplete
        label={TEXTS.article}
        value={articleId}
        options={options}
        sx={drawerFieldSpan(6)}
        onChange={(event) => setArticleId(event.target.value)}
        disabled={disabled}
      />
      <Box sx={drawerFieldSpan(3)}>
        <DecimalTextField
          label={TEXTS.total}
          value={total}
          decimals={3}
          onChange={(event) => setTotal(event.target.value)}
          disabled={disabled}
          error={total !== '' && !proposal}
        />
      </Box>
      <CustomButton
        variant="outlined"
        sx={drawerFieldSpan(3)}
        disabled={disabled || !articleId || !proposal}
        onClick={() => onAllocation(proposal)}
      >
        {TEXTS.propose}
      </CustomButton>
    </DrawerFormSection>
  );
};
export default ReceiptAllocationFields;
